// Shared palette for ad-classification charts. Used by ResearchDashboard, the
// admin overview Dashboard, and any future surface that visualises gambling
// categories or platform splits.

export const GAMBLING_COLORS: Record<string, string> = {
  gambling_pachinko: '#f59e0b',
  gambling_online: '#ef4444',
  gambling_public: '#3b82f6',
  gambling_game: '#8b5cf6',
  gambling_gacha_premium: '#ec4899',
};

export const LEGAL_COLORS: Record<string, string> = {
  legal: '#22c55e',
  illegal: '#ef4444',
  gray_zone: '#f59e0b',
  unknown: '#6b7280',
};

export const PLATFORM_COLORS: Record<string, string> = {
  youtube: '#ef4444',
  facebook: '#1877f2',
  instagram: '#e4405f',
  tiktok: '#000000',
  x_twitter: '#1da1f2',
  generic: '#9ca3af',
};

export const PLATFORM_EMOJI: Record<string, string> = {
  youtube: '📺',
  facebook: '👍',
  instagram: '📷',
  tiktok: '🎵',
  x_twitter: '𝕏',
  generic: '🌐',
};

// Legal status grouping for gambling categories. Reflects Hirano-san's editorial
// stance: pachinko / public lotteries / game-style gambling are legal in Japan;
// online gambling is illegal; gacha-premium sits in a grey zone.
export const LEGAL_GAMBLING_CATEGORIES = ['gambling_pachinko', 'gambling_public', 'gambling_game'] as const;
export const ILLEGAL_GAMBLING_CATEGORIES = ['gambling_online'] as const;
export const GRAY_ZONE_GAMBLING_CATEGORIES = ['gambling_gacha_premium'] as const;
